import { render } from "./NotesAndTerms.vue?vue&type=template&id=5ca80e40"
import script from "./NotesAndTerms.vue?vue&type=script&lang=js"
export * from "./NotesAndTerms.vue?vue&type=script&lang=js"
script.render = render

export default script